import { Suspense } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import SectionTabs from '../../../components/common/SectionTabs.jsx'
import { useCurrentUser } from '../../../hooks/useCurrentUser.js'
import { ACCOUNT_SECTIONS } from '../sections.js'

/**
 * Compte : tout ce qui concerne le compte au même endroit (crédits, activités, organisation,
 * agences et administration selon les droits).
 *   /dashboard/compte            -> Crédits
 *   /dashboard/compte/:section   -> la sous-page choisie
 */
export default function AccountPage() {
  const { section: sectionKey } = useParams()
  const { user, isLoading } = useCurrentUser()

  if (isLoading) return null

  const sections = ACCOUNT_SECTIONS.filter((s) => s.visible(user))
  const section = sections.find((s) => s.key === sectionKey)
  if (!section) return <Navigate to={`/dashboard/compte/${sections[0].key}`} replace />

  const Screen = section.component

  return (
    <div>
      <SectionTabs
        label="Compte"
        activeKey={section.key}
        tabs={sections.map((s) => ({ ...s, to: `/dashboard/compte/${s.key}` }))}
      />
      <Suspense
        fallback={(
          <div className="flex items-center justify-center py-20 text-white/50">
            <Loader2 className="h-5 w-5 animate-spin" />
          </div>
        )}
      >
        <Screen />
      </Suspense>
    </div>
  )
}
